import { SimpleHeroStandard } from "../../../../modules/simple-hero/components/SimpleHeroStandard/SimpleHeroStandard";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = (props: ISimpleHeroBlockProps) => {
  if (!props.eyebrow && !props.heading && !props.description && !props.buttons?.length) {
    return null;
  }

  return <SimpleHeroStandard {...props} />;
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
